<form [formGroup]="userForm" (ngSubmit)="onSubmit()" novalidate #uForm="ngForm">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group">
              <label for="name">Name</label>
              <input type="text" class="form-control" id="name" formControlName="name">
              <div *ngIf="name.invalid && (name.dirty || name.touched)" class="alert alert-danger">
                <div *ngIf="name.errors.required">
                  Name is required.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="email">Email</label>
              <input class="form-control" type="text" formControlName="email" id="email">
              <div *ngIf="email.invalid && (uForm.submitted || email.dirty || email.touched)" class="alert alert-danger">
                <div *ngIf="email.errors.required">
                  Email address is required.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="password">Password</label>
              <input class="form-control" type="password" formControlName="password"  id="password">
              <div *ngIf="password.invalid && (uForm.submitted || password.dirty || password.touched)" class="alert alert-danger">
                <div *ngIf="password.errors.required">
                  password is required.
                </div>
                <div *ngIf="password.errors.minlength">
                  Password must be at least 6 characters long.
                </div>
              </div>
            </div>
            <div class="form-group">
              <label for="password_confirmation">Confirm password</label>
              <input class="form-control" type="password" formControlName="password_confirmation"  id="password_confirmation">
              <div *ngIf="password_confirmation.invalid && (uForm.submitted || password_confirmation.dirty || password_confirmation.touched)" class="alert alert-danger">
                <div *ngIf="password_confirmation.errors.required">
                  password is required.
                </div>
                <div *ngIf="password_confirmation.errors.minlength">
                  Password must be at least 6 characters long.
                </div>
              </div>
            </div>

            <div class="form-group">
              <input type="checkbox" id="isAdmin" name="isAdmin" formControlName="isAdmin" /> Admin account
            </div>
            <div class="form-group">
              <input type="checkbox" id="notificationsEnabled" name="notificationsEnabled" formControlName="notificationsEnabled" />Notifications enable
            </div>
            <!--<div class="form-group">-->
              <!--<input type="checkbox" id="isActive" name="isActive" formControlName="isActive" /> Active-->
            <!--</div>-->
          </div>
        </div>
        <div class="card">

          <div class="card-footer">
            <button type="reset" class="btn btn-sm btn-danger" (click)="onCancel()">
              <i class="fa fa-ban"></i> cancel</button>
            <button type="submit" class="btn btn-sm btn-primary">
              <i class="fa fa-dot-circle-o"></i> Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>